export default "__VITE_ASSET__C1GH6bCL__"